export enum AmiSiteType {
  Management,
  Dealer,
  Customer,
  ShopFloor
}
